<template>
  <!-- only used for CPS on topoguide view -->
  <fa-icon icon="star" />
</template>
